import React from "react"
import { Link } from "react-router-dom"
import * as moment from "moment"
import { size, map } from "lodash"

const Name = cell => {
  return cell.value ? cell.value : "-"
}

const ShortDescription = cell => {
  return cell.value ? (
    <div>
      {cell.value.length > 50
        ? cell.value.substring(0, 50) + "..."
        : cell.value}
    </div>
  ) : (
    "---"
  )
}

export { Name, ShortDescription }
